import { render } from "./AuthEmail.vue?vue&type=template&id=5d29431a&scoped=true"
import script from "./AuthEmail.vue?vue&type=script&lang=js"
export * from "./AuthEmail.vue?vue&type=script&lang=js"

import "./AuthEmail.vue?vue&type=style&index=0&id=5d29431a&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d29431a"]])

export default __exports__